import API from "@/lib/API";

export const initialQuotationService = {
  getInitialQuotations: async (params = {}) => {
    return await API.get('/verve-leads', { params });
  },

  submitInitialQuotation: async (id, data) => {
    // Re-use the existing endpoint logic that ChangeStatusForm was hitting, or update lead directly
    // The previous form was hitting POST /initial-quotations, wait... 
    // Wait, let's check how the previous form submitted the initial quotation update.
    // If it's an update on an existing quotation, maybe we hit a different endpoint?
    // Let's look at `ChangeStatusForm.jsx`: it hits `await api.post('/initial-quotations', ...)` and then `await onConfirm(finalData)` which calls `handleUpdateLead(id, data)`.
    // I'll provide an update endpoint for just the lead data.
    return await API.put(`/verve-leads/${id}`, data);
  },

  deleteInitialQuotation: async (id) => {
    return await API.delete(`/verve-leads/${id}`);
  },

  updateLead: async (id, data) => {
    return await API.put(`/verve-leads/${id}`, data);
  }
};
